module.exports = __webpack_public_path__ + "img/02-babo-02.6ccdbc2f.png";